module.exports = __webpack_public_path__ + "img/eye.9689576f.svg";